import css from "./NewUserCredentials.css";
import PropTypes from "prop-types";
import React from "react";
import Icon from '../SF/MaterialIcon';
import NewUserCredentialsRow from "./NewUserCredentialsRow";
import SortableTable from "../SF/table/SortableTable";
import { CSVLink } from "react-csv";
import StyledButton from "../common/StyledButton";

/**
 * Displays the access key and secret access key in a modal after a new IAM user is created. Once the modal is
 * closed, the tenant admin will no longer have access to the secret access key.
 *
 * @param {Object} props - see propTypes
 * @returns {JSX.Element} The modal contents after creating a new access key
 */
const NewUserCredentials = (props) => {

    const getHeaders = () => {
        const headers = []
        headers.push(
            {content: 'Access Key'},
            {content: 'Secret Access Key'}
        )
        return headers
    }

    const renderCredentials = (credentials, index) => {
        return <NewUserCredentialsRow {...credentials}
                                      index={index}
                                      key={index}
                                      showSecretKey={props.showSecretKey}
                                      onClickShowSecretKey={props.onClickShowSecretKey}/>
    }

    const getCredentials = () => {
        return [{"accessKey": props.accessKey, "secretAccessKey": props.secretAccessKey}]
    }

    const getCredentialsTable = () => {
        return (
            <div className={css['table']}>
                <SortableTable columnToSort="Access Key"
                               headers={getHeaders()}
                               items={getCredentials()}
                               shouldPaginate={false}
                               renderItem={renderCredentials}/>
            </div>
        )
    }

    return (
        <div>
            <p className={css['text']}>This access key will have controlled permissions to access reports.  This is the only
                time the secret access key will be available.  You cannot recover it later if it
                is lost.  However, you can generate a new key at any time.</p>
            <StyledButton
                aria-disabled={false}
                className={css['download-button']}
                id="download-credentials"
                arial-label="download-credentials">
                <div>
                    <Icon
                        className={css['download-icon']}
                        icon='file_download'
                        aria-hidden='true'/>
                    <CSVLink
                        data={getCredentials()}
                        filename="eab-data-extracts-credentials.csv"
                        className={css['link']}>
                        Download
                    </CSVLink>
                </div>
            </StyledButton>
            {getCredentialsTable()}
        </div>
    )
}

NewUserCredentials.propTypes = {
    accessKey: PropTypes.string,
    secretAccessKey: PropTypes.string,
    showSecretKey: PropTypes.bool.isRequired,
    onClickShowSecretKey: PropTypes.func.isRequired
}

export default NewUserCredentials
